// ═══════════════════════════════════════════════════════════════
// Global theme context — dark (default) ↔ light.
// Persisted in localStorage under `ire_theme`.
// Currently visually applies to:
//   • Objekte hub (/objekte)
//   • Homepage Objekte teaser strip
//   • Navigation navbar (subtle bg + text swap)
//   • <html data-theme="…"> so future pages can hook into CSS vars
// Other pages remain dark until their design pass.
// ═══════════════════════════════════════════════════════════════
import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();
const STORAGE_KEY = "ire_theme";
const VALID = ["dark", "light"];

const resolveInitial = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && VALID.includes(stored)) return stored;
  } catch (e) { /* SSR / restricted */ }
  return "dark";
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(resolveInitial);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) { /* ignore */ }
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
